import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, UrlTree } from '@angular/router';

import { LocalStorageService } from '@services/local-storage.service';

/**
 * Route guard to check if the current user has access based on their role.
 * It reads the user's role from LocalStorageService and compares it
 * against the list of allowed roles provided in the route's data.
 */
export const HasAccessByRoleGuard: CanActivateFn = (route: ActivatedRouteSnapshot): UrlTree | boolean => {
  const localStorageService = inject(LocalStorageService);

  const currentUserRole = localStorageService.getCurrentUserRole();
  const allowedRoles = route.data?.allowedRoles ?? [];

  return allowedRoles.length ? allowedRoles.includes(currentUserRole) : true;
};
